import Dexie from "dexie";
import db from "../Db";

var DeleteProcedureAbandon = Dexie.async(function* () {
  yield db.open();
  yield db.PROCEDUREABANDON.clear();
});

export default DeleteProcedureAbandon;
